import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output} from "@angular/core";
import * as _ from "lodash";

require('./route-editable-list-item.scss');
@Component({
  standalone: false,
  selector: 'app-route-editable-list-item',
  templateUrl: './route-editable-list-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RouteEditableListItemComponent implements OnInit {

  @Input() task: any;
  @Input() index: number;
  @Input() job?: any;
  @Input() route?: any;

  public routeColor: string;
  // Never assigned - bundle weight is computed only in the AngularJS planning-route-tasks-table-row.
  public bundleWeight: string;

  constructor(@Inject('planningCommonService') private planningCommonService, @Inject('$timeout') private $timeout) {}

  ngOnInit() {
    this.setRouteColor();
  }

  private setRouteColor() {
    this.routeColor = this.planningCommonService.getRouteColor(this.route);
  }

}
